import React, { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  isSelected?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  children,
  loading,
  isSelected = true,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <Container type="button" isSelected={isSelected} {...rest}>
      {loading ? t('components:feedback.loading') : children}
    </Container>
  );
};

export default Button;
